
import React from 'react';
import { FileText, Download, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Reveal } from '../Reveal';
import { Button } from '../Button';

export const AGBPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="pt-32 pb-20 bg-gray-50 min-h-screen">
            <div className="max-w-3xl mx-auto px-6 text-center">

                <Reveal>
                    <div className="inline-flex items-center justify-center p-4 bg-white border border-gray-200 rounded-full mb-8 shadow-sm">
                        <FileText size={32} className="text-clever-teal" />
                    </div>
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
                        {t('shared.legal.agb.title')}
                    </h1>
                    <p className="text-xl text-gray-500 mb-12 max-w-lg mx-auto leading-relaxed">
                        {t('shared.legal.agb.subtitle')}
                    </p>
                </Reveal>

                <Reveal delay={0.1}>
                    <div className="bg-white border border-gray-200 rounded-2xl p-10 shadow-lg max-w-md mx-auto relative overflow-hidden group">
                        <div className="absolute top-0 left-0 w-full h-1 bg-clever-teal"></div>

                        <div className="mb-8 relative z-10">
                            <div className="w-20 h-24 border-2 border-gray-200 bg-gray-50 mx-auto rounded flex items-center justify-center mb-4 group-hover:border-clever-teal/50 transition-colors">
                                <span className="font-bold text-gray-400 text-xs">PDF</span>
                            </div>
                            <h3 className="font-bold text-gray-900 text-lg">
                                {t('shared.legal.agb.file_name')}
                            </h3>
                            <p className="text-sm text-gray-500 mt-2">
                                {t('shared.legal.agb.version_info')}
                            </p>
                        </div>

                        <div className="space-y-4 relative z-10">
                            <a href="/documents/AGB_CleverDigital.pdf" download className="block w-full">
                                <Button variant="primary" className="w-full justify-center gap-2 py-4">
                                    <Download size={18} /> {t('shared.legal.agb.download_button')}
                                </Button>
                            </a>
                            <a href="/documents/AGB_CleverDigital.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 text-sm text-gray-500 hover:text-clever-teal transition-colors py-2 font-medium">
                                {t('shared.legal.agb.open_browser')} <ArrowRight size={14} />
                            </a>
                        </div>

                        {/* Background Decoration */}
                        <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-clever-teal/5 rounded-full blur-3xl pointer-events-none group-hover:bg-clever-teal/10 transition-colors"></div>
                    </div>
                </Reveal>

            </div>
        </div>
    );
};
